/**
 * @file オプション有無
 */
'use strict';

/**
 * @classname RadioOptionView
 * @classdesc オプション有無
 */
export default class RadioOptionView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('RadioOptionView.constructor');
		this._$e = $e;
		this._$input = $e.find('input[type=radio]');
		this._$description = $('.option_description');
		this.init();
		$e.on('click', () => {this.onClick();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	init() {
		console.log('RadioOptionView.init');
		if($('input.option_id:checked').val() === 'on'){
			$('.block-option-info').slideDown();
			this._$description.removeClass('ignore-validate');
		}
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onClick() {
		console.log('RadioOptionView.onClick');
		$('.block-has-option').find('.error-tip').removeClass('show');
		if(this._$input.val() === 'on'){
			$('.block-option-info').slideDown();
			this._$description.removeClass('ignore-validate');
		}else{
			$('.block-option-info').slideUp();
			this._$description.removeClass('is-invalid').addClass('ignore-validate');
			this._$description.closest('.validate-group').find('.error-tip').removeClass('show').find('.error-tip-inner').html('');
		}
	};
}
